export const DEFAULT_LABEL_COLOR = 'pastel-blue';
export const INCLUSION_LABEL_COLOR = 'yellow';

export const LABEL_COLOR_OPTIONS = [
	// ROYGBIV ordering
	{value:'red', display:'Red'},
	{value:'bright-red', display:'Bright Red'},
	{value:'orange', display:'Orange'},
	{value:'dark-orange', display:'Dark Orange'},
	{value:'pastel-orange', display:'Pastel Orange'},
	{value:'green', display:'Green'},
	{value:'turquoise', display:'Turquoise'},
	{value:'blue', display:'Blue'},
	{value:'bright-blue', display:'Bright Blue'},
	{value:'pastel-blue', display:'Pastel Blue'},
	{value:'dark-blue', display:'Dark Blue'},
	{value:'dark-blue-gray', display:'Dark Blue Gray'},
	{value:'pastel-dark-blue-gray', display:'Pastel Dark Blue Gray'},
	{value:'purple', display:'Purple'},
	{value:'bright-purple', display:'Bright Purple'},
	{value:'dark-purple', display:'Dark Purple'},
	{value:'dark-purple-gray', display:'Dark Purple Gray'},
	{value:'pastel-dark-purple', display:'Pastel Dark Purple'},
	// additional neutrals
	{value:'dark-brown', display:'Dark Brown'},
];

const COLOR_ALIAS_MAP = {
	'bright_red': 'bright-red',
	'dark_blue': 'dark-blue',
	'dark_blue_gray': 'dark-blue-gray',
	'dark_blue_grey': 'dark-blue-gray',
	'pastel_dark_blue_gray': 'pastel-dark-blue-gray',
	'pastel_dark_blue_grey': 'pastel-dark-blue-gray',
	'dark_purple_gray': 'dark-purple-gray',
	'dark_purple_grey': 'dark-purple-gray',
};

const LOW_CONTRAST_COLOR_MAP = {
	'yellow': 'dark-orange',
	'bright-yellow': 'dark-orange',
	'pastel-light-yellow': 'dark-orange',
	'pastel-yellow': 'orange',
	'pastel-light-orange': 'pastel-orange',
	'bright-green': 'green',
	'pastel-light-green': 'green',
	'pastel-green': 'green',
	'pastel-light-turquoise': 'turquoise',
	'pastel-turquoise': 'turquoise',
	'pastel-light-blue': 'blue',
	'pastel-light-purple': 'bright-purple',
	'pastel-brown': 'dark-brown',
};

const VALID_COLOR_CLASSES = new Set([...LABEL_COLOR_OPTIONS.map(option => option.value), INCLUSION_LABEL_COLOR]);

const normalizeColorClass = (tag_color) => {
	if(!tag_color) return null;
	const normalized_tag_color = `${tag_color}`.trim().toLowerCase().replace(/_/g, '-');
	if(normalized_tag_color in COLOR_ALIAS_MAP) return COLOR_ALIAS_MAP[normalized_tag_color];

	let mapped_tag_color = normalized_tag_color;
	if(mapped_tag_color === 'dark-blue-grey') mapped_tag_color = 'dark-blue-gray';
	if(mapped_tag_color === 'pastel-dark-blue-grey') mapped_tag_color = 'pastel-dark-blue-gray';
	if(mapped_tag_color === 'dark-purple-grey') mapped_tag_color = 'dark-purple-gray';
	if(mapped_tag_color in LOW_CONTRAST_COLOR_MAP) mapped_tag_color = LOW_CONTRAST_COLOR_MAP[mapped_tag_color];

	return mapped_tag_color;
};

export const isInclusionLabel = (label_info) => {
	if(!label_info || !('label' in label_info)) return false;
	return `${label_info.label}`.trim().toLowerCase() === 'inclusion';
};

export const getLabelColorClass = (label_info) => {
	if(isInclusionLabel(label_info)) return INCLUSION_LABEL_COLOR;

	const normalized_tag_color = normalizeColorClass(label_info && label_info.tag_color);
	if(normalized_tag_color && VALID_COLOR_CLASSES.has(normalized_tag_color)) return normalized_tag_color;

	return DEFAULT_LABEL_COLOR;
};

export const getLabelTextColorClass = (label_info) => {
	const color_class = getLabelColorClass(label_info);

	if(color_class === 'bright-purple') return 'purple-text';
	if(color_class === 'dark-blue-gray') return 'dark-blue-gray-text';
	if(color_class === 'pastel-dark-blue-gray') return 'pastel-dark-blue-gray-text';
	if(color_class === 'dark-purple-gray') return 'dark-purple-gray-text';

	return `${color_class}-text`;
};

export const getLabelLinkColorClass = (label_info) => {
	const color_class = getLabelColorClass(label_info);
	if(color_class === 'dark-blue') return 'dark-blue-gray-link';
	return `${color_class}-link`;
};
